/*
 * Copyright 2012 Sagarana Tech.  All rigths reserved.
 *
 * This software is the confidential and proprietary information of
 * Sagarana Tech ("Confidential Information"). You shall not disclose such
 * Confidential Information and shall use it only in accordance with the
 * terms of the license agreement you entered into with Sagarana Tech.
 *
 */

/**
 * Faz o Depart no Stop
 *
 * @author Mozart Diniz mozartdiniz@sagaranatech.com
 * DATE: 25/03/2013
 */


Greenmile.Stop = Greenmile.Stop || {};

Greenmile.Stop.Depart = function ({
  parentSelector = '#RouteSummary',
  successCallback
} = {}) {


    Greenmile.Stop.Base.call(this);

    /**
     * Monta a estrutura base do formulário, pega o template e insere o conteúdo no modalForm
     */

    this.getLayout = function (data) {
        return new Monet.UI.LayoutGenerator({
            "items": [
                {
                    "tag": "form",
                    "items": [
                        {
                            "items": [
                                {
                                    "attributes": {
                                        "class": "monetInlineAlerContainer"
                                    }
                                },
                                {
                                    "items": [
                                        {
                                            "attributes": {
                                                "class": "popup-modal-header"
                                            },
                                            "items": [
                                                {
                                                    "tag": "h3",
                                                    "html": data.btnSaveValue,
                                                },
                                                {
                                                    "tag": "div",
                                                    "items": [
                                                        {
                                                            "tag": "a",
                                                            "attributes": {
                                                                "href": "https://greenmile.help.descartesservices.com",
                                                                "class": "MonetUIHelpLink",
                                                                "title": "Help"
                                                            },
                                                        }
                                                    ],
                                                    "attributes": {
                                                        "class": "MonetUIHelp"
                                                    },
                                                }
                                            ]
                                        },
                                        {
                                            "tag": "div",
                                            "attributes": {
                                                "class": "popup-modal-body"
                                            },
                                            "items": [
                                                {
                                                    "tag": "label",
                                                    "beforeHtml": data.dateTimeField.label,
                                                    "attributes": {
                                                        "class": "control-label",
                                                        "for": data.dateTimeField.name
                                                    }
                                                },
                                                {
                                                    "tag": "input",
                                                    "attributes": {
                                                        "type": "text",
                                                        "id": data.dateTimeField.name,
                                                        "value": data.dateTimeField.value,
                                                        "name": data.dateTimeField.name,
                                                        "class": "dateTimePicker"
                                                    }
                                                },
                                                {
                                                    "tag": "label",
                                                    "beforeHtml": data.drivers.label,
                                                    "attributes": {
                                                        "class": "control-label",
                                                        "for": data.drivers.name
                                                    }
                                                },
                                                {
                                                    "tag": "select",
                                                    "attributes": {
                                                        "name": data.drivers.name,
                                                        "id": data.drivers.name
                                                    }
                                                }
                                            ]
                                        },
                                        {
                                            "tag": "div",
                                            "attributes": {
                                                "class": "popup-modal-footer formButtons"
                                            },
                                            "items": [
                                                {
                                                    "tag": "input",
                                                    "attributes": {
                                                        "type": "button",
                                                        "value": data.btnSaveValue,
                                                        "name": "btn_save_depart_stop",
                                                        "id": "btn_save_depart_stop",
                                                        "class": "btn",
                                                        "style": "width: 170px"
                                                    }
                                                },
                                                {
                                                    "tag": "input",
                                                    "attributes": {
                                                        "type": "button",
                                                        "value": data.btnExitValue,
                                                        "name": "btn_exit_depart_stop",
                                                        "id": "btn_exit_depart_stop",
                                                        "class": "btn secondary",
                                                        "style": "width: 75px"
                                                    }
                                                }
                                            ],
                                        }

                                    ]
                                }
                            ]
                        }
                    ],
                    "attributes": {
                        "id": "formDepartStopFormTemplate"
                    }
                }
            ]
        }).render();
    };

    this.createForm = function () {
        const date = new Monet.Date.GeneralFunctions();
        const modalContainer = document.querySelector(`${parentSelector} .popupFormContainer`);
        const util = Greenmile.Stop.Util;

        if (modalContainer) {

            modalContainer.appendChild(this.getLayout({
                btnSaveValue: Monet.I18n.getResourcesByKey('Greenmile.Stop.Depart.btnSave'),
                btnExitValue: Monet.I18n.getResourcesByKey('Greenmile.Stop.Depart.btnExit'),
                dateTimeField: util.getParametersToTemplate('Greenmile.Stop.Depart.dateTimeFieldLabel', 'departTime', date.getCurrentDateAndTime()),
                drivers: util.getParametersToTemplate('Greenmile.Stop.Depart.driversList', 'driversList')
            }));

            date.setDateTimePicker(`${parentSelector} .popupFormContainer .dateTimePicker`);

        } else {
            new Monet.Exception.ReturnError(this, "No .popupFormContainer found.")
                .console();
        }

    };

    this.populateDriversList = function (drivers) {

        var undeliverableCodeElement = document.querySelector("#formDepartStopFormTemplate #driversList");
        var driverLabel = document.querySelector("label[for='driversList']");
        var error = null;

        undeliverableCodeElement.innerHTML = "";

        if (typeof(drivers) !== "undefined") {

            if (drivers.length > 0) {

                driverLabel.style.display = 'block';

                for (var i = 0, j = drivers.length; i < j; i++) {

                    var option = document.createElement("option");

                    option.value = drivers[i].driver.id;
                    option.text = drivers[i].driver.name;

                    undeliverableCodeElement.appendChild(option);
                }
            } else {
                driverLabel.style.display = 'none';
            }


        } else {

            error = new Monet.Exception.ReturnError(this,
                "No collection loaded");
            error.console();

        }

    };

    this.addEventListenners = function () {

        var that    = this,
            btnSave = null,
            btnExit = null;

        try {

            btnSave = document.querySelector("#formDepartStopFormTemplate #btn_save_depart_stop");
            btnExit = document.querySelector("#formDepartStopFormTemplate #btn_exit_depart_stop");

            btnExit.onclick = function () {
                that.modalForm.closeModalWindow();
            };

            btnSave.onclick = function () {
                that.doDepart();
            };

        } catch (e) {

            var error = new Monet.Exception.ReturnError(this, "No add event listenner to form.");
            error.console();

        }

    };

    this.doDepart = function () {

        var isValid = this.validateForm();
        var formDataJson = {};
        var driverParameter = "/NoDriver";
        var that = this;
        var error = null;

        if (isValid) {

            formDataJson = this.getFormValues();

            if (this.routeId) {
                if (this.stop) {
                    this.modalForm.toggleLoadingInModalBtn();

                    if (formDataJson.driverId) {
                        driverParameter = "/Driver?id=" + formDataJson.driverId;
                    }

                    const ajax = new Monet.Ajax();

                    const stopKey = this.stop.get("stop").key;
                    const parsedStopKey = Greenmile.Stop.Util.formatStopKey(stopKey);

                    ajax.url = `Route/${this.routeId}/Stop/${parsedStopKey}/Depart${driverParameter}`;
                    ajax.method = 'POST';
                    ajax.data = '{"actualDeparture": "' + formDataJson.stop.actualDeparture + '"}';
                    ajax.success = (data) => {
                        that.modalForm.closeModalWindow();

                        if (successCallback) {
                          successCallback();
                        } else {
                          App.Forms.RouteSummaryStops.pagination.first = 0;
                          that.successCallback(data);
                        }
                    };
                    ajax.error = (data) => {
                        that.modalForm.toggleLoadingInModalBtn();
                        that.errorCallback(data);
                    };
                    ajax.send();

                } else {
                    error = new Monet.Exception.ReturnError(this,
                        "Stop can't be null");
                    error.console();
                }

            } else {

                error = new Monet.Exception.ReturnError(this,
                    "routeId can't be null");
                error.console();

            }
        }

    };

    this.getFormValues = function () {

        var departTimeField = document.querySelector("#formDepartStopFormTemplate .dateTimePicker");
        var driver = document.getElementById("driversList");

        const formattedDate = Monet.Format.DateTime.parseLocaleToISOString(departTimeField.value);

        var objToSend = {
            stop: {
                actualDeparture: formattedDate
            },
            driverId: driver.value
        };

        return objToSend;
    };

    this.validateForm = function () {

        var error;
        var isValid = true;
        var departDate = document.getElementById("departTime");
        var driversList = document.getElementById("driversList");
        var routeActualStart = this.stop.get('route').actualStart;
        var stopActualArrival = this.stop.get("stop").actualArrival;
        var utils = new Greenmile.Route.ModalUtils();
        var scopeMessage = '#formDepartStopFormTemplate';
        var departTimeTimeMili = null;
        var stopActualArrivalMili = Monet.Format.DateTime.parse(stopActualArrival).getTime();
        var routeStartTimeMili = Monet.Format.DateTime.parse(routeActualStart).getTime();

        try {

            if (departDate.value.trim() === "") {

                utils.showErrorMessage(
                    scopeMessage,
                    "depart_date",
                    "Stop.Depart.cantDepartWhitouDateTime"
                );

                isValid = false;

            } else {

                departTimeTimeMili = Monet.Format.DateTime.parseLocale(departDate.value).getTime();

                if (departTimeTimeMili <= stopActualArrivalMili || departTimeTimeMili <= routeStartTimeMili) {

                    utils.showErrorMessage(
                        scopeMessage,
                        "date_before_route_and_stop",
                        "Stop.Return.cantReturnBeforeGreaterArrive"
                    );

                    isValid = false;

                } else {

                    if (driversList.value === "" && driversList.style.display === "block") {

                        utils.showErrorMessage(
                            scopeMessage,
                            "driver",
                            "Stop.Depart.cantDepartWhitouDriver"
                        );

                        isValid = false;

                    } else {

                        if (departTimeTimeMili > new Date().getTime()) {

                            utils.showErrorMessage(
                                scopeMessage,
                                "driver",
                                "Stop.Arrive.cantDepartInTheFuture"
                            );

                            isValid = false;

                        }

                    }

                }

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "No validate form.");
            error.console();

        }

        return isValid;
    };

    this.createAllStructure = function (scope) {
        return function () {
            scope.prepareToCreateForm();
            scope.createForm();
            scope.loadDriverData();
            scope.addEventListenners();
        };
    }(this);

    const init = function (scope) {

        return function (scope) {

            const selector = parentSelector;
            const scopeBlock = ".mainContainer";

            const options = {
                width: 280,
                height: 258
            };

            const callbacks = {
                onAfterShowModalForm: scope.createAllStructure
            };

            scope.modalForm = new Monet.Form.Modal(selector, options, callbacks, scopeBlock);

        }(scope);

    };

    init(this);

};
